import { DialogConfirm } from '@components/dialogConfirm/DialogConfirm'
import { getAverageRGB } from '@components/utils/getAverageRGB'
import { useEffect, useState } from 'react'

type Props = {
  file: File
  onChange: (value: string) => void
}
export const ChangePrimaryColor = ({ file, onChange }: Props) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false)
  const [copyFile, setCopyFile] = useState<File | null>(null)

  useEffect(() => {
    if (!!copyFile && copyFile.lastModified !== file.lastModified) {
      setIsOpenDialog(true)
    }
    setCopyFile(file)
  }, [file])

  return (
    <DialogConfirm
      open={isOpenDialog}
      title="Would you like to change the primary color?"
      text="Based on the colors in the uploaded logo, we can try to determine the dominant color. Confirm if you want to conduct analysis."
      onConfirm={() => {
        const img = new Image()
        img.src = URL.createObjectURL(file)
        img.crossOrigin = ''

        img.onload = () => {
          onChange(getAverageRGB(img).hex)
          setIsOpenDialog(false)
        }
      }}
      onCancel={() => {
        setIsOpenDialog(false)
      }}
    />
  )
}
